<template>
  <div>
    <v-card v-if="items"
    class="mx-auto pl-2"
    max-width="500"
    >
    
    <v-snackbar 
      v-model="snackbar" 
      timeout="2000" 
      :color="snackbarColor"
      absolute
      top>
      {{ snackbarMessage }}
    </v-snackbar>

    <v-card-title class="pl-3 d-flex justify-space-between">
      Update Pipelines
      <v-btn icon @click="$emit('hide-list-manager', true)">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
      
    <v-card-subtitle class="pl-3">
          Manage which of your pipelines you want the selected notice(s) assigned to. Your current selections are <span style="color:rgb(255, 20, 99);">highlighted</span> below.
        </v-card-subtitle>
    <v-container class="py-0">
      <v-row
        align="center"
        justify="start"
      >
        <v-card flat class="px-2 py-2 mx-2 my-2" height="320" style="flex-grow: 1 !important; overflow:auto !important;">
          <v-overlay :value="loading" absolute :opacity="0.7">
            <v-progress-circular indeterminate size="36" color="primary"></v-progress-circular>
          </v-overlay>

          <v-text-field
            v-model="newPipelineName"
            dense
            solo-inverted
            hide-details
            flat
            append-outer-icon="mdi-plus-circle-outline"
            label="New pipeline name..."
            @click:append-outer="postPipeline()"
            @keyup.enter="postPipeline()"
          ></v-text-field>

          <v-list-item-group multiple>
            <v-list-item v-for="pipeline in currentItems" :key="pipeline.id">
              <v-list-item-action>
                <v-checkbox 
                :input-value="exists(pipeline)" 
                @change="togglePipelineSelections(pipeline.id)"
                color="primary"
                ></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ pipeline.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-card>
      </v-row>
    </v-container>

    <v-divider></v-divider>
    <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="$emit('hide-list-manager', true)">
            Cancel
          </v-btn>

          <v-btn
            color="secondary"
            text
            @click="savePipelineSelection"
          >
            Save
          </v-btn>
        </v-card-actions>
  </v-card>
  <v-card v-else flat class="ma-0 pa-0">
      <v-card-title>No pipelines found</v-card-title>
      <v-card-text>
        <p>
          You can create pipelines and then add any target tenders and
          contracts to those lists. This gives you quick access to those
          lists whenever you need them.
        </p>
        <p>
          Click <router-link to="/pipelines" style="color: white!important; text-decoration: none;">
                    here
                  </router-link> to create your first pipeline.
        </p>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="$emit('hide-list-manager', true)">
            OK
          </v-btn>
        </v-card-actions>
       </v-card-text
      ></v-card
    >
  </div>
</template>
<script>
import { bus } from '../main'
import { getPipelines, updatePipelines, addPipeline } from './APIManager'

export default {
  components: {
  },

  props: {
    //results_drawer: Boolean
    targetItem: {},
    items: [],
    selected: [],
    changed: Number
  },

  data() {
    return {
      localSelected: [...this.selected],
      loading: false,
      newPipelineName: '',
      currentItems: [],
      snackbar: false,
      snackbarMessage: '',
      snackbarColor: 'success'
    };
  },
  
  mounted: function() {
    this.currentItems = this.items;
    this.localSelected = this.selected.map(item => 
    typeof item === 'object' && item !== null ? item.id : item
  );
  },

  computed: {},
  watch: {},

  methods: {
    
    exists(pipeline) {
      // ////console.log("Checking if pipeline should be selected:", pipeline.id, pipeline.search_query.tender_id.includes(parseInt(this.targetItem.id)));
      if (!pipeline.search_query || !pipeline.search_query.tender_id) {
        return false;
      }
      return pipeline.search_query.tender_id.includes(parseInt(this.targetItem.id)) &&
       this.localSelected.includes(pipeline.id);
    },

    togglePipelineSelections(pipelineId) {
      //////console.log("Toggling pipeline:", pipelineId);

      // Ensure selected array only contains IDs, not objects
      const selectedIds = this.localSelected.map(item => 
        typeof item === 'object' && item !== null ? item.id : item
      );

      if (selectedIds.includes(pipelineId)) {
        // Remove if already selected
        this.localSelected = selectedIds.filter(id => id !== pipelineId);
      } else {
        // Add if not selected
        this.localSelected = [...selectedIds, pipelineId];
      }
    },
        

    async postPipeline() {
      if (!this.newPipelineName.trim()){

        this.snackbarMessage = "Please enter a valid pipeline name.";
        this.snackbarColor = "warning"; 
        this.snackbar = true;
        return;
      }

      const existingPipeline = this.currentItems.find(pipeline => 
      pipeline.name.toLowerCase() === this.newPipelineName.trim().toLowerCase()
    );

    if (existingPipeline) {
      this.snackbarMessage = "Pipeline name already exists. Choose a different name.";
      this.snackbarColor = "error";
      this.snackbar = true;
      return;
    }

      this.loading = true;

      try{
        // ////console.log("Sending request:", this.newPipelineName);
        const response = await addPipeline(encodeURIComponent(this.newPipelineName.trim()));

        if (response && response.status === 'success' && response.data) {
          //clear the input field and refresh pipeline list
          this.newPipelineName = "";
          await this.loadPipelines();
          this.snackbarMessage = "Sucessfullty added pipeline.";
          this.snackbarColor = "success";
          this.snackbar = true;
          // ////console.log("Pipeline list after refresh:", this.items);
        }
        else {
          this.snackbarMessage = "Failed to add pipeline. Please try again.";
          this.snackbarColor = "error";
          this.snackbar = true;
        }  
      }
      catch (error) {
        ////console.error("Error adding pipeline:", error);
      }
      this.loading = false;
    },

    async loadPipelines() {
      this.loading = true;

      try {
        const results = await getPipelines();
        //////console.log("Loaded pipelines:", results);
        this.$set(this, 'currentItems', results.data);
      } catch (error) {
        ////console.error("Error loading pipelines:", error);
      }
      this.loading = false;
    },

    async savePipelineSelection() {

      this.loading = true;

      try {
        // Update the database with the selected pipelines
        // Emit event to notify parent component
        //////console.log("Selected ID: ", this.localSelected)
        await updatePipelines(this.targetItem.id, this.localSelected);
        this.$emit('pipeline-updated', {
          tender_id: this.targetItem.id,
          selectedLists: this.localSelected
        });

        this.snackbarMessage = "Pipeline selection saved successfully!";
        this.snackbar = true;
      } catch (error) {
        ////console.error("Error saving pipeline selections:", error);
      }
      this.loading = false;
    }
  }
}
</script>